<template>
  <v-container>
    <avs-backButton
      v-if="!inDialog"
      backTo="PcqDsis"
    />
    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <template v-slot:headers>
        <AvsStep step="1">
          {{ $t("General") }}
          <small v-show="!isFormValid.generale">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
        <v-divider></v-divider>
        <AvsStep step="2">
          {{ $tc("Execution (Contractor)", 2) }}
          <small v-show="!isFormValid.execution">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
        <v-divider></v-divider>
        <AvsStep step="3">
          {{ $t("Inspection parties") }}
          <small v-show="!isFormValid.inspectionPartie">{{
            $t("commons.validation_issues")
          }}</small>
        </AvsStep>
        <v-divider></v-divider>
        <AvsStep step="4">
          {{ $t("Record") }}
          <small v-show="!isFormValid.record">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
      </template>
      <template v-slot:items>
        <v-stepper-content step="1">
          <v-form
            ref="form-generale"
            v-model="isFormValid.generale"
            class="pt-2"
            lazy-validation
          >
            <v-text-field
              clearable
              type="text"
              v-model="pcqDsi.order"
              :label="$t('Order.')"
              dense
              outlined
              :rules="rules.order"
            />
            <!-- <template v-if="pcqDsi.task && pcqDsi.task.id"> -->
            <TaskInput
              v-model="pcqDsi.task"
              dense
              outlined
              disabled
              :rules="rules.task"
            ></TaskInput>

            <v-text-field
              v-if="pcqDsi.task === null || pcqDsi.task.name === ''"
              clearable
              @input="handleInput"
              type="text"
              v-model="pcqDsi.name"
              :label="$t('Name.')"
              dense
              outlined
              :rules="rules.name"
            />

            <v-select
              v-model="pcqDsi.pia"
              :rules="rules.pia"
              :items="statusItems"
              dense
              outlined
              :label="$t('PIA (Y/N)')"
            ></v-select>

            <v-textarea
              v-model="pcqDsi.applicable_document"
              :rules="rules.applicable_document"
              clearable
              dense
              outlined
              :label="$t('Applicable documents')"
              rows="5"
            />
            <v-text-field
              clearable
              @input="handleInput"
              type="text"
              v-model="pcqDsi.doc_rev"
              :label="$t('Doc rev.')"
              dense
              outlined
              :rules="rules.doc_rev"
            />
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-form
            ref="form-execution"
            v-model="isFormValid.execution"
            class="pt-2"
            lazy-validation
          >
            <v-col
              cols="12"
              class="pt-0 d-flex justify-center"
            >
              <v-row class="mt-0 d-flex align-baseline mb-4">
                <ImageInputOther
                  v-model="pcqDsi.performer"
                  dense
                  @updateDisabled="updateDisabled"
                  :disabled="disabled"
                  :labelText="performer_label"
                />
                <ImageInputOther
                  v-model="pcqDsi.quality_control"
                  @updateDisabled="updateDisabled"
                  dense
                  :disabled="disabled"
                  :labelText="quality_label"
                />
                <ImageInputOther
                  v-model="pcqDsi.technical_control"
                  @updateDisabled="updateDisabled"
                  :disabled="disabled"
                  dense
                  :labelText="technical_label"
                />
              </v-row>
            </v-col>
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-form
            ref="form-inspection-partie"
            v-model="isFormValid.inspectionPartie"
            class="pt-2"
            lazy-validation
          >
            <v-row class="mt-4 d-flex align-baseline mb-4">
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold"
              >
                {{ $t("A") }}
                <QualityPointInput
                  v-model="pcqDsi.quality_point_a"
                  @input="handleInput"
                  :label="$t('PIA')"
                  :rules="rules.quality_point_a"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold text-center"
              >
                <ImageInputOther
                  v-model="pcqDsi.part_a"
                  :disabled="disabled"
                  @updateDisabled="updateDisabled"
                  dense
                  :labelText="partA_label"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4 d-flex align-baseline mb-4 justify-center">
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold"
              >
                {{ $t("B") }}
                <QualityPointInput
                  v-model="pcqDsi.quality_point_b"
                  @input="handleInput"
                  :label="$t('PIA')"
                  :rules="rules.quality_point_b"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold justify-center"
              >
                <ImageInputOther
                  v-model="pcqDsi.part_b"
                  @updateDisabled="updateDisabled"
                  :disabled="disabled"
                  dense
                  :labelText="partB_label"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4 d-flex align-baseline mb-4">
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold"
              >
                {{ $t("C") }}
                <QualityPointInput
                  v-model="pcqDsi.quality_point_c"
                  @input="handleInput"
                  :rules="rules.quality_point_c"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold text-center"
              >
                <ImageInputOther
                  v-model="pcqDsi.part_c"
                  @updateDisabled="updateDisabled"
                  dense
                  :disabled="disabled"
                  :labelText="partC_label"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4 d-flex align-baseline mb-4">
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold"
              >
                {{ $t("D") }}
                <QualityPointInput
                  v-model="pcqDsi.quality_point_d"
                  @input="handleInput"
                  :rules="rules.quality_point_d"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="primary--text font-weight-bold text-center justify-content-center"
              >
                <ImageInputOther
                  v-model="pcqDsi.part_d"
                  @updateDisabled="updateDisabled"
                  :disabled="disabled"
                  dense
                  :labelText="partD_label"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-form
            ref="form-record"
            v-model="isFormValid.record"
            class="pt-2"
            lazy-validation
          >
            <v-select
              v-model="pcqDsi.record"
              :items="statusItems"
              dense
              outlined
              :label="$t('Record (Y/N)')"
              :rules="rules.record"
            ></v-select>
            <v-text-field
              clearable
              @input="handleInput"
              type="text"
              v-model="pcqDsi.reference"
              :label="$t('Record reference')"
              dense
              outlined
              :rules="rules.reference"
            />
            <v-textarea
              v-model="pcqDsi.observation"
              clearable
              dense
              outlined
              :label="$t('NCR/DR Observation')"
              rows="5"
              :rules="rules.observation"
            />
          </v-form>
        </v-stepper-content>
      </template>
      <v-spacer></v-spacer>
      <template v-slot:actions>
        <avs-stepButton
          class="mx-2"
          icon="mdi-chevron-left"
          @click="tab--"
          :disabled="tab <= 1"
          :name="$t('commons.previous')"
        />
        <avs-stepButton
          class="mx-2"
          icon="mdi-chevron-right"
          right
          @click="tabIncrement"
          :name="nextLabel"
        />
      </template>
    </AvsSteppers>
  </v-container>
</template>

<script>
import _ from "lodash"

import { PcqDsiService } from "@/services"
// import { NEXT, YES_NO_ITEMS } from "@/utils/consts"
import { YES_NO_ITEMS } from "@/utils/consts"
import { mkPcqDsi } from "@/utils/datamodels"

import { ImageInputOther, TaskInput } from "@/components"
import { required, isNumber } from "@/utils/validator"

export default {
  name: "PcqDsiCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue"),
    QualityPointInput: () => import("@/components/inputs/QualityPointInput.vue"),
    TaskInput,
    ImageInputOther
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      performer_label: "Perfomer",
      quality_label: "Quality Control",
      technical_label: "Technical Controle Performer",
      partA_label: "Part A",
      partB_label: "Part B",
      partC_label: "Part c",
      partD_label: "Part D",
      pcqDsiRef: null,
      pcqDsi: mkPcqDsi(),
      deleteDialogIsOpen: false,
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      nextLabel: this.$t("commons.next"), //NEXT.DEFAULT,
      loading: false,
      step: -1,
      disabled: false,
      rules: {
        name: [required],
        pia: [],
        applicable_document: [],
        doc_rev: [],
        performer: [],
        quality_control: [],
        technical_control: [],
        quality_point_a: [],
        quality_point_b: [],
        quality_point_c: [],
        quality_point_d: [],
        record: [],
        reference: [],
        observation: [],
        part_a: [],
        part_b: [],
        part_c: [],
        part_d: [],
        order: [required, isNumber]
      },
      isFormValid: {
        generale: false,
        execution: false,
        inspectionPartie: false,
        record: false
      },
      validateRequest: {
        pictures: 0
      },
      areasData: {}
    }
  },
  created() {
    this.fetchPcqDsi()
  },
  methods: {
    save() {
      this.$refs["form-generale"].validate()
      this.$refs["form-execution"].validate()
      this.$refs["form-inspection-partie"].validate()
      this.$refs["form-record"].validate()
      this.$nextTick(() => {
        if (
          this.isFormValid.generale &&
          this.isFormValid.execution &&
          this.isFormValid.inspectionPartie &&
          this.isFormValid.record
        )
          if (this.pcqDsiExists) {
            this.updatePcqDsi()
            this.$router.push({ name: "PcqDsis" })
          } else {
            this.createPcqDsi()
            this.$router.push({ name: "PcqDsis" })
          }
        else {
          this.tab = 1
          const message = this.$t("messages.warning.all_required_info")
          this.send(message, "warning")
        }
      })
    },
    tabIncrement() {
      return this.tab < 5 ? this.tab++ : this.$router.push({ name: "PcqDsisView" })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    getPcqDsi(id) {
      if (id) {
        let t = this
        PcqDsiService.get(this, this.projectId, id).then(r => {
          t.pcqDsi = r
          t.pcqDsiRef = _.cloneDeep(t.pcqDsi)
        })
      }
    },
    createPcqDsi() {
      let tmp = _.cloneDeep(this.pcqDsi)

      // We rename "file_url" to "file" for the create to work
      this.loading = true
      PcqDsiService.create(this, this.projectId, tmp)
        .then(response => {
          this.pcqDsi = response
          this.pcqDsiRef = _.cloneDeep(response)
          this.send(
            this.$t("messages.success.saved", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            "success"
          )
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "  "
            }
            this.send(message, "error")
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePcqDsi() {
      const requests = []
      const pcqDsiAttrs = [
        "order",
        "name",
        "task",
        "pia",
        "applicable_document",
        "doc_rev",
        "performer",
        "quality_control",
        "technical_control",
        "quality_point_a",
        "quality_point_b",
        "quality_point_c",
        "quality_point_d",
        "record",
        "reference",
        "observation",
        "part_a",
        "part_b",
        "part_c",
        "part_d"
      ]
      if (!_.isEqual(_.pick(this.pcqDsi, pcqDsiAttrs), _.pick(this.pcqDsiRef, pcqDsiAttrs))) {
        requests.push(PcqDsiService.update(this, this.pcqDsi.id, this.pcqDsi))
      }
      if (requests.length > 0) {
        this.loading = true
        // Promise.all(requests)
        PcqDsiService.update(this, this.pcqDsi.id, this.pcqDsi)
          .then(() => {
            this.send(
              this.$t("messages.success.updated", {
                entity: this.$tc("categories.pcqdsi.name", 1)
              }),
              "success"
            )
          })
          .catch(err => {
            if (err.response && err.response.status === 403) {
              // alert("Access denied: You do not have permission to access this resource.")
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            } else {
              let message = ""
              for (const e in err.response.data) {
                message += "- " + e + " : " + err.response.data[e] + "  "
              }
              this.send(message, "error")
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.send(this.$t("messages.success.no_updated"), "info")
      }
    },
    fetchPcqDsi() {
      // Load nonconformity
      this.getPcqDsi(this.id)
    },
    handleInput() {
      this.$emit("input", this.pcqDsi)
    },
    updateDisabled(newStatus) {
      this.disabled = newStatus
    }
  },
  watch: {
    tab(newValue, oldValue) {
      if (oldValue === 1 && newValue === 2) {
        this.tab = this.$refs["form-generale"].validate() ? 2 : 1
      } else if (oldValue === 2 && newValue === 3) {
        this.tab = this.$refs["form-execution"].validate() ? 3 : 2
      } else if (oldValue === 3 && newValue === 4) {
        this.tab = this.$refs["form-inspection-partie"].validate() ? 4 : 3
      } else if (oldValue === 4 && newValue === 5) {
        this.save()
      }

      // Set Save label
      if (newValue === 4) {
        this.nextLabel = this.$t("commons.finish") //NEXT.FINISH
      } else {
        this.nextLabel = this.$t("commons.next") //NEXT.DEFAULT
      }
    }
  },
  computed: {
    statusItems() {
      return YES_NO_ITEMS
    },
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    },
    pcqDsiExists() {
      return this.pcqDsi.id > 0
    },
    projectId() {
      return this.$store.state.app.project.id
    },
    projectRole() {
      return this.$store.state.app.project.role
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.stepper-item {
  flex: 1 1 auto;
  overflow-y: auto;
}
</style>
